import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const SectionWrapper = styled.div`
  margin-bottom: 24px;
`

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${myPalette.midnightBlue.main};
`

export const FieldWrapper = styled.div`
  margin-bottom: 12px;
`

export const CurrentValueHint = styled.div`
  font-size: 12px;
  color: ${myPalette.dark.main};
  margin-top: 4px;
  margin-left: 4px;
`

export const HeaderDescription = styled.div`
  font-size: 14px;
  color: ${myPalette.dark.main};
  margin-bottom: 24px;
`
